/**
 * Textos y rutas del menú Mi perfil (PBI 81715).
 */
export const LABELS = {
  editarPerfil: 'Editar perfil',
  seleccionarCuenta: 'Seleccionar cuenta',
  administracionUsuarios: 'Administración de usuarios',
  cerrarSesion: 'Cerrar sesión',
  ddjjPendiente: 'DDJJ pendiente',
  cuenta: 'Cuenta',
  cuit: 'CUIT',
  contrato: 'Contrato',
  ejecutivo: 'Ejecutivo',
}

export const RUTAS = {
  miPerfil: '/mi-perfil',
  // Ruta exterior del shell (microfrontend de administracion-usuario, ver
  // src/common/config/microfrontends.config.js). `/admin-usuarios` era la ruta standalone.
  adminUsuarios: '/administracion-usuarios',
}
